import BreadCrumb from "../../../../components/breadcrumb";
import Header from "../../../../components/DashboardNavigation/header";
import Sidebar from "../../../../components/DashboardNavigation/sidebar";
import { EventData } from "../../../../components/tables/events-tables/event";
import { useEffect, useState } from "react";
import { Event } from "../../../../data/types";
import { getAllEvents } from "../../../../API/Events/eventService";

const breadcrumbItems = [
  { title: "Événements", link: "/admin-dashboard/evenements" },
];
export default function Events() {
  const [events, setEvents] = useState<Event[]>([]);
  const fetchData = async () => {
    const response = await getAllEvents();
    setEvents(response?.events);
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <Header />
      <div className="flex h-screen overflow-hidden">
        <Sidebar />
        <div className="flex-1 p-4 pt-6 space-y-4 md:p-8">
          <BreadCrumb items={breadcrumbItems} />
          <EventData data={events} />
        </div>
      </div>
    </>
  );
}
